export * from './skyscraper6.component';